import React, {
  createContext,
  useContext,
  useEffect,
  useState
} from 'react';

import {
  getAdminProfile,
  logout as logoutAPI,
  verifyToken as verifyTokenAPI
} from '@/services/api';


const AuthContext = createContext();


export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(
      'useAuth must be used within AuthProvider'
    );
  }

  return context;
};


export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] =
    useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('admin_token');

    if (!token) {
      setIsAuthenticated(false);
      setUser(null);
      setIsLoading(false);
      return;
    }

    try {
      const response = await verifyTokenAPI();

      setIsAuthenticated(true);
      setUser(
        response.user || {
          username: response.username,
          role: response.role
        }
      );
    } catch (error) {
      localStorage.removeItem('admin_token');
      setIsAuthenticated(false);
      setUser(null);
    } finally {
      setIsLoading(false);
    }
  };

  const login = (token, userData) => {
    localStorage.setItem('admin_token', token);
    setIsAuthenticated(true);

    setUser(
      typeof userData === 'string'
        ? { username: userData }
        : userData
    );
  };

  const refreshProfile = async () => {
    const profile = await getAdminProfile();
    setUser(profile);
    return profile;
  };

  const logout = async () => {
    try {
      await logoutAPI();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('admin_token');
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        user,
        login,
        logout,
        checkAuth,
        refreshProfile
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
